var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    d: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:none;stroke:#B73F3F;stroke-width:20;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.21,357.51L491.21,357.51c-6.89,4.66-16.25,2.84-20.91-4.05l-94.24-139.51 c-4.66-6.89-2.84-16.25,4.05-20.91l0,0c6.89-4.66,16.25-2.84,20.91,4.05l94.24,139.51C499.91,343.49,498.1,352.85,491.21,357.51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.53,357.51L163.53,357.51c6.89,4.66,16.25,2.84,20.91-4.05l94.24-139.51c4.66-6.89,2.84-16.25-4.05-20.91 l0,0c-6.89-4.66-16.25-2.84-20.91,4.05L159.48,336.6C154.83,343.49,156.64,352.85,163.53,357.51z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M532.84,378.58H121.9c-8.39,0-15.2-6.8-15.2-15.2v-17.73c0-8.39,6.8-15.2,15.2-15.2h410.95 c8.39,0,15.2,6.8,15.2,15.2v17.73C548.04,371.78,541.24,378.58,532.84,378.58z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.37,650.33L351.08,506.7c-4.89-10.77,6.18-21.84,16.95-16.95l143.62,65.29c9.8,4.45,10.06,18.29,0.43,23.1 l-44.59,22.29c-2.48,1.24-4.49,3.25-5.72,5.72l-22.3,44.6C434.65,660.38,420.82,660.13,416.37,650.33L416.37,650.33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.08,506.7c-4.89-10.77,6.18-21.84,16.95-16.95l87.44,39.75l37.79-150.92H161.48l55.08,219.96h176.27 L351.08,506.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.24e893a5db84345102170009fc5c78ec.svg";
export { ForwardRef as ReactComponent };